__turbopack_context__.v({
  "cell": "Lx3plW_cell",
  "dense": "Lx3plW_dense",
  "table": "Lx3plW_table",
  "tableWrapper": "Lx3plW_tableWrapper",
  "tbody": "Lx3plW_tbody",
  "thead": "Lx3plW_thead",
  "title": "Lx3plW_title",
});
